import React, { useState, useEffect } from 'react';
import '@ant-design/compatible';
import { ApolloProvider } from '@apollo/react-hooks';
import cubejs from '@cubejs-client/core';
import { CubeProvider } from '@cubejs-client/react';
import client from './graphql/client';
import ExplorePage from './pages/ExplorePage';
import { firebaseAuth } from '../firebase';
import LoadingSpinner from '../LoadingSpinner';

// const API_URL = 'http://localhost:4000';
// const API_URL = 'https://ivory-cardinal.aws-us-west-2.cubecloudapp.dev/'
// const API_URL ='https://glorious-foosland.aws-us-west-2.cubecloudapp.dev';
const API_URL = 'https://vermillion-cube.fly.dev';
//const CUBEJS_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE2Njk2NjY0OTgsImV4cCI6MTY2OTc1Mjg5OH0.6pfQLRcbc9-fA1_xcryNMY4hFnshzdzyqXgGB-R5Okg';
// const CUBEJS_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE2NzI2OTAzMzV9.64zMtOOjxuvLqzGt8r2v_eWvMKz3yV_5E5mynYqo5xM';
// const CUBEJS_TOKEN ='eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE3MTQ1MjY0NjN9.l627Cy81cl-mS3S3cS3bX8511TjppIwD_i7e22EuyYc';

const getCubeToken = async () => {
  if (firebaseAuth.currentUser) {
    const token = await firebaseAuth.currentUser.getIdToken();
    console.log('Cube.js dynamic token retrieved:', token);
    return token;
  }
  console.log('No current user to get token for Cube.js');
  return '';
};

// Intercept fetch to log Cube.js requests
const originalFetch = window.fetch;
window.fetch = async (...args) => {
  const [resource, config] = args;
  const url = typeof resource === 'string' ? resource : (resource?.url || '');
  if (url.includes('cubejs-api') || url.includes('/v1/')) {
    console.log('Cube.js Request URL:', url);
    console.log('Cube.js Request Method:', config?.method || 'GET');
    console.log('Cube.js Request Headers:', config?.headers);
  }
  return originalFetch(...args);
};

// Use dynamic token to ensure correct signature
const cubejsApi = cubejs(getCubeToken, {
  apiUrl: `${API_URL}/cubejs-api/v1`,
});

const App = (props) => {
  const [isAuthReady, setAuthReady] = useState(false);

  useEffect(() => {
    const unsubscribe = firebaseAuth.onAuthStateChanged(() => {
      setAuthReady(true);
      // Wait for the first state to arrive, then stop listening if you want
      // Or we can leave the listener running if we want to handle logouts actively
    });
    return () => unsubscribe();
  }, []);

  if (!isAuthReady) {
    return <LoadingSpinner />;
  }

  return (
    <CubeProvider cubejsApi={cubejsApi}>
      <ApolloProvider client={client}>
        <ExplorePage {...props} />
      </ApolloProvider>
    </CubeProvider>
  );
};

export default App;
